module.exports = __webpack_public_path__ + "img/top_size.96d6281a.png";